module.exports = __webpack_public_path__ + "img/12.39e15958.jpg";